import React from 'react';

type AgreementProps = {
  ofertaText: string | null;
};

const Agreement = ({ ofertaText }: AgreementProps) => (
  // eslint-disable-next-line react/no-danger
  <>{ofertaText && <div dangerouslySetInnerHTML={{ __html: ofertaText }} />}</>
);

export default Agreement;
